import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import AurmSiteRoute from '../components/landing/AurmSite';

/**
 * One design, every route. `AurmSiteRoute` reads the path and renders the home
 * page or the matching inner page from the Aurm design handoff.
 */
function AppRouter() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<AurmSiteRoute route="home" />} />
        <Route path="/our_story" element={<AurmSiteRoute route="story" />} />
        <Route path="/blogs" element={<AurmSiteRoute route="blog" />} />
        <Route path="/individual_blogs/:blogId" element={<AurmSiteRoute route="article" />} />
        <Route path="/faq" element={<AurmSiteRoute route="faq" />} />
        <Route path="/careers" element={<AurmSiteRoute route="careers" />} />
        <Route path="/corporate" element={<AurmSiteRoute route="corporate" />} />
        <Route path="/apps" element={<AurmSiteRoute route="app" />} />
        <Route path="/terms-and-conditions" element={<AurmSiteRoute route="terms" />} />
        <Route path="/privacy-policy" element={<AurmSiteRoute route="privacy" />} />
        <Route path="/refund-policy" element={<AurmSiteRoute route="refund" />} />
        <Route path="*" element={<AurmSiteRoute route="home" />} />
      </Routes>
    </Router>
  );
}

export default AppRouter;
